module.exports = __webpack_public_path__ + "img/sad-computer.85fa6b8b.png";